{
  "footer-powered-by": "Réalisé par ",
  "footer-extra": ", une entreprise de Boise ID",
  "loading": "Chargement…",
  "errorTitle": "Impossible de charger cette page",
  "networkError": "Vérifiez votre connexion et réessayez.",
  "retry": "Réessayer",
  "footer-get-app": "Téléchargez l'application <ios>iOS</ios> ou <android>Android</android> pour voir plus de contenu de votre église."
}
